import EventEmitter from 'events'
import axios from 'axios'
class getMeta extends EventEmitter {
	constructor() {
		super()
	}
	get(card){
		var that = this

		var apikey = "28c12ec129ebac041e1cf7";

		var getUrl = "https://iframe.ly/api/iframely?url=" + card.url + "&api_key=" + apikey

		axios.get(getUrl)
		  .then(function (response) {
		    var item = response.data

		    card.title = item.meta.title

		    if(item.meta.site){
		    	card.source = item.meta.site
		    }
		    card.snippet = item.meta.description

		    if(item.meta.author) {
		    	card.author = item.meta.author
		    }

		    // check if there is thumbnail
		    if(item.links.thumbnail.length > 0){
    			card.image = item.links.thumbnail[0].href	
    		}

    		//check if there is icon
    		if(item.links.icon.length > 0){
    			var icons = item.links.icon
    			for (var icon of icons) {
    				if(icon.type == 'image/icon' || icon.type == 'image/x-icon') {
    					card.icon = icon.href 
    				}
    			}
    		}

    		switch(item.meta.site.toLowerCase()) {
    			case 'youtube':
    				card.type = 'video';
    				card.length = item.meta.duration;
    				break;
    			case 'ted':
    				card.type = 'video';
    				break;
    			case 'goodreads':
    				card.type = 'book';
    				break;
    			default:
    				card.type = 'link';
    		}

		    that.emit('metad')
		  })
		  .catch(function (error) {
		    that.emit('meta.error')
		  });

	}
}
export default new getMeta()


// WEBPACK FOOTER //
// ./src/data/getMeta.js